import React from "react";
import "./style.scss";

export default function ErrorModal({ message, onClose }) {
  if (!message) return null;
  return (
    <div className="error-modal-wrap">
      <div className="error-modal">
        <div className="error-modal-heading">Có lỗi xảy ra</div>
        <div className="error-modal-body">
          <pre className="message">{String(message)}</pre>
        </div>
        <div className="error-modal-footer">
          <button onClick={onClose}>Đóng</button>
        </div>
      </div>
    </div>
  );
}

